import React from 'react';

import {
    mobileSupportPageSignal,
    mobileSupportRetryPageSignal,
} from 'features/mobile-report/state/mobile-report.signals';
import { Button } from 'ui-components/button/button';
import { ImgWithFallback } from 'features/mobile-report/shared/components/img-with-fallback/img-with-fallback';
import chatIllustration from 'components/assets/Icons/mobile/chat-illustration.webp';
import chatIllustrationFallback from 'components/assets/Icons/mobile/chat-illustration.avif';

import styles from './mobile-support-pages.module.scss';

export const SupportFailedMobile = () => {
    const handleRetry = () => {
        mobileSupportPageSignal.value = mobileSupportRetryPageSignal.value;
    };

    const handleClose = () => {
        mobileSupportPageSignal.value = undefined;
    };

    return (
        <>
            <div className={styles.messageBody}>
                <ImgWithFallback
                    src={chatIllustration}
                    fallbackSrc={chatIllustrationFallback}
                    alt="error"
                    className={styles.messageImage}
                />
                <h1 className={styles.messageTitle}>We Couldn’t Submit the Ticket</h1>
                <p className={styles.messageDescription}>
                    If the issue persists, contact support at{' '}
                    <a href="mailto:support@placer.ai" className={styles.contactLink}>
                        support@placer.ai
                    </a>
                </p>
            </div>
            <div className={styles.buttons}>
                <Button
                    className={styles.mainButton}
                    type="primary"
                    onClick={handleRetry}
                    data-testid="support-failed-mobile-retry"
                >
                    Retry
                </Button>
                <div
                    className={styles.secondButton}
                    onClick={handleClose}
                    data-touchable
                    data-testid="support-failed-mobile-close"
                >
                    Close
                </div>
            </div>
        </>
    );
};
